module.exports = __webpack_public_path__ + "img/device-mobile.70bf68fb.svg";